module.exports = __webpack_public_path__ + "img/money.b7a408f1.png";